import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HEIGHT: number = gridSize * 6;
export const BANNER_NAME = 'EOC_TRANSITION' as const;
